import IntercomService from '../../../intercom/IntercomService';

export abstract class EventAdapter {
  protected eventData: any = {};
  protected abstract intercomEventKey: string = null;
  protected abstract amplitudeEventFunction: (data: unknown) => void;

  public sendAnalytics() {
    __DEV__ && console.log('Send Analytics', this.eventData);

    try {
      this.sendIntercomEvent();
    } catch (err) {
      console.error('Failed to send intercom event', err);
    }

    try {
      this.sendAmplitudeEvent();
    } catch (err) {
      console.error('Failed to send amplitude event', err);
    }
  }

  protected sendIntercomEvent() {
    if (this.intercomEventKey) {
      IntercomService.event(this.intercomEventKey);
    }
  }

  protected sendAmplitudeEvent() {
    if (this.amplitudeEventFunction) {
      this.amplitudeEventFunction(this.eventData);
    }
  }
}
